import { DateTime } from "luxon";
import { useCallback, useEffect } from "react";
import { Dimensions } from "react-native";
import { graphql, useMutation } from "react-relay";

import { useInterval } from "widgets/useInterval";

import { currentLatency } from "../../Client";
import { registerAliveMutation } from "./__generated__/registerAliveMutation.graphql";

export const useRegisterAliveDevice = (screenId: string) => {
  const [mutate] = useMutation<registerAliveMutation>(graphql`
    mutation registerAliveMutation(
      $screenId: ID!
      $latency: Int
      $screenWidth: Int
      $screenHeight: Int
      $screenScale: Float
      $timeZone: String
      $clientTime: String
    ) {
      storecast {
        registerAliveDevice(
          screenId: $screenId
          latency: $latency
          screenWidth: $screenWidth
          screenHeight: $screenHeight
          screenScale: $screenScale
          timeZone: $timeZone
          clientTime: $clientTime
        )
      }
    }
  `);

  const notifyAlive = useCallback(() => {
    const screen = Dimensions.get("screen");
    mutate({
      variables: {
        screenId,
        screenWidth: screen.width,
        screenHeight: screen.height,
        screenScale: screen.scale,
        timeZone: DateTime.local().zoneName,
        latency: currentLatency ? Math.floor(currentLatency) : undefined,
        clientTime: DateTime.local().toISO(),
      },
      onError: (e) => {
        console.log("failed to register device alive");
      },
    });
  }, [mutate, screenId]);

  useEffect(() => {
    notifyAlive();
  }, [notifyAlive, screenId]);

  useInterval(() => {
    notifyAlive();
  }, 60000);
};
